export class ActionButton {
    private readonly button: HTMLElement;
    private readonly callback: (button?: HTMLElement) => void;

    constructor(querySelector: string, callback: (button?: HTMLElement) => void) {
        this.button = document.getElementById(querySelector) as HTMLElement;
        this.callback = callback;
        this.attachClickHandler();
    }

    private attachClickHandler(): void {
        this.button.addEventListener('click', () => {
            this.callback(this.button);
        });
    }
}